export const MARKETO_ACCOUNTS_PAGE_TITLE = 'Loading Marketo Leads';
export const MARKETO_SUMMARY_LOAD = 'Please wait for the leads from ' +
            'your Marketo account to load in order to match to your segment.';
